//import React from 'react';

//import React,{useState} from 'react';  
//import { Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import paths from '../../../routes/paths';
// import { fetchProducts } from '../../redux/slices/ProductsSlice';
 import {useSelector } from 'react-redux';
// import { ThunkDispatch } from '@reduxjs/toolkit';
import ProfileIcon from '../../../assets/images/profile.png'

const  Sidebar = ({selectedLink}) => {
   const {loggedInUser} = useSelector((state:any) => state.auth)
  // const dispatch = useDispatch<ThunkDispatch<any,any,any>>();

  // useEffect(() =>{
  //   dispatch(fetchProducts());
  // },[])
 
  return (
    <aside className="col-xl-3">
		<div className="toggle-info">
			<h5 className="title mb-0">Account Navbar</h5>
			<a className="toggle-btn" href="#accountSidebar">Account Menu</a>
		</div>
		<div className="sticky-top account-sidebar-wrapper">
			<div className="account-sidebar" id="accountSidebar">
				<div className="profile-head">
					<div className="user-thumb">
						<img className="rounded-circle" src={ProfileIcon} alt="Profile Icon"/>
					</div>
					<h5 className="title mb-0">{loggedInUser && loggedInUser.name}</h5>
					<span className="text text-primary">{loggedInUser && loggedInUser.email}</span>
				</div>
				<div className="account-nav">
					<div className="nav-title bg-light">DASHBOARD</div>
					<ul>
						<li key="Dashboard" className={selectedLink === 'Dashboard' ? 'active' : ''}><Link  to={paths.userDashboard}>Dashboard</Link></li>
						<li key="orders" className={selectedLink === 'My Orders' ? 'active' : ''}><Link to={paths.userOrders} >My Orders</Link></li> 
						<li key="wishlist" className={selectedLink === 'My Wishlist' ? 'active' : ''}><Link to={paths.userWishlist}  >My Wishlist</Link></li> 
					</ul>
					<div className="nav-title bg-light">ACCOUNT SETTINGS</div>
					<ul className="account-info-list">
						<li key="profile" className={selectedLink === 'My Profile' ? 'active' : ''}><Link to={paths.userProfile} >My Profile</Link></li>
						<li key="addresses" className={selectedLink === 'My Addresses' ? 'active' : ''}><Link to={paths.userAddresses}  >My Addresses</Link></li>
					</ul>
				</div>
			</div>
		</div>
    </aside>
  );
}

export default Sidebar;

 
